var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondominium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1C2033",
    width: 52,
    height: 52,
    id: "lni_lni-condominium",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57,18h-5v-7c0-3.3-2.6-5.9-5.9-5.9H17.9C14.6,5.1,12,7.8,12,11v7H7c-2.9,0-5.3,2.4-5.3,5.3v30.3c0,2.9,2.4,5.3,5.3,5.3h50 c2.9,0,5.3-2.4,5.3-5.3V23.3C62.3,20.4,59.9,18,57,18z M6.3,53.6V23.3c0-0.4,0.3-0.8,0.8-0.8h5v31.8H7C6.6,54.4,6.3,54,6.3,53.6z  M16.5,20.3V11c0-0.8,0.6-1.4,1.4-1.4h28.2c0.8,0,1.4,0.6,1.4,1.4v9.2v34.1h-6.8v-8.7c0-2.3-1.9-4.3-4.3-4.3h-9 c-2.3,0-4.3,1.9-4.3,4.3v8.7h-6.8V20.3z M27.8,54.4v-8.5h8.5v8.5H27.8z M57.8,53.6c0,0.4-0.3,0.8-0.8,0.8h-5V22.5h5 c0.4,0,0.8,0.3,0.8,0.8V53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1,24.1h7.2c1.2,0,2.3-1,2.3-2.3v-7.2c0-1.2-1-2.3-2.3-2.3h-7.2c-1.2,0-2.3,1-2.3,2.3v7.2 C18.8,23.1,19.8,24.1,21.1,24.1z M23.3,16.9h2.7v2.7h-2.7V16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7,24.1h7.2c1.2,0,2.3-1,2.3-2.3v-7.2c0-1.2-1-2.3-2.3-2.3h-7.2c-1.2,0-2.3,1-2.3,2.3v7.2 C33.4,23.1,34.4,24.1,35.7,24.1z M37.9,16.9h2.7v2.7h-2.7V16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3,37.5c1.2,0,2.3-1,2.3-2.3V28c0-1.2-1-2.3-2.3-2.3h-7.2c-1.2,0-2.3,1-2.3,2.3v7.2c0,1.2,1,2.3,2.3,2.3H28.3z  M23.3,30.3h2.7V33h-2.7V30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7,37.5h7.2c1.2,0,2.3-1,2.3-2.3V28c0-1.2-1-2.3-2.3-2.3h-7.2c-1.2,0-2.3,1-2.3,2.3v7.2C33.4,36.5,34.4,37.5,35.7,37.5z  M37.9,30.3h2.7V33h-2.7V30.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondominium);
export default __webpack_public_path__ + "static/media/condominium.23522383bcab9f8ba8a393830e872f46.svg";
export { ForwardRef as ReactComponent };